import { useQuery } from '@tanstack/react-query'
import { createFileRoute, Link } from '@tanstack/react-router'
import z from 'zod'
import { AppContainer } from '~/components/new/app-ui/app-container'
import { RotationFormPage } from '~/components/routes/product-rotations/rotation-form-page'
import { RotationFormSkeleton } from '~/components/routes/product-rotations/rotation-form-skeleton'
import { rotationQueryOptions } from '~/lib/product-rotations-query'
import { ROTATIONS_READ } from '~/components/routes/product-rotations/rotation-ui'
import { getTuyauErrorMessage } from '~/lib/utils'
import { withRoutePermissions } from '~/utils/rbac'

export const Route = createFileRoute('/_authenticated/product-rotations/$id')({
  staticData: {
    permission: ROTATIONS_READ,
  },
  component: ProductRotationPage,
  params: {
    parse: z.object({ id: z.coerce.number() }).parse,
  },
})
withRoutePermissions(Route)

function ProductRotationPage() {
  const { id } = Route.useParams()
  const { data: rotation, error } = useQuery(rotationQueryOptions(id))

  if (error) {
    return (
      <AppContainer className="items-start">
        <p className="text-sm text-destructive">
          {getTuyauErrorMessage(error, 'Rotation introuvable')}
        </p>
        <Link to="/product-rotations" className="text-sm underline">
          Revenir aux rotations
        </Link>
      </AppContainer>
    )
  }
  if (!rotation) return <RotationFormSkeleton />
  // La clé remonte le formulaire sur une autre rotation : ses valeurs initiales en dépendent.
  return <RotationFormPage key={rotation.id} rotation={rotation} />
}
